import React, { useState, useEffect } from 'react';
import fallbackImage from '../../../assets/images/image-unavailable.svg';
import styles from './ImageWithFallback.module.css';

const ImageWithFallback = ({
    src,
    customClass = '',
    isUrlImage = false //For cases where URL images are meant to be pulled from external sites
}) => {
    //imgSrc is to be inserted file name Ex: 'watchImg.gif' for dynamic file paths - Or full URL for external IMG
    const [imgSrc, setImgSrc] = useState(src);
    const [imgPath, setImgPath] = useState(null);
    const [imgClass, setImgClass] = useState(customClass);
    const [error, setError] = useState(false);
    const [importing, setImporting] = useState(true);

    const handleImageError = () => {
        if (!error) {
            setImgPath(fallbackImage); // Set the path to the fallback image
            setImgClass(styles.errorImgClass); //Passed CSS class for image if failed to load should be overwritten by error styling here if needed
            setError(true);
        }
    };

    useEffect(() => {
        if (isUrlImage) {
            setImporting(true);
            setImgPath(imgSrc);
            setImporting(false);
        } else {
            try {
                setImporting(true);
                //Logic for basePaths will need to be updated dependent on directory of dynamically created image paths
                let imgTemp = require(`../../../assets/images/Vendor/Apple/WatchBands/${imgSrc}`);
                setImgPath(imgTemp);
                setImporting(false);
            } catch (e) {
                handleImageError();
                setImporting(false);
            }
        }
    }, [src]);

    if (importing) {
        return null;
    }

    return (
        <img
            src={imgPath}
            className={imgClass}
            onError={handleImageError}
        />
    );
};

export default ImageWithFallback;
